import { Table } from '@octano/global-ui';
import { useMemo, useRef } from 'react';
import { useNonStructuredSectionsLoader } from '../hooks/NonStructuredSectionsLoader';
import useSectionsColumns from '../hooks/useSectionsColumns';
import SectionTeachersModal, {
  SectionTeachersModalMethods,
} from './SectionTeachersModal';

const SectionsTable = () => {
  const sectionTeachersModalRef = useRef<SectionTeachersModalMethods>(null);
  const {
    result,
    loading,
    query,
    updateQuery,
  } = useNonStructuredSectionsLoader();

  const handleOpenTeachersModal = (name: string, teachers: string[]) => {
    sectionTeachersModalRef.current?.open(name, teachers);
  };

  const columns = useSectionsColumns({
    onOpenTeachersModal: handleOpenTeachersModal,
  });

  const data = useMemo(() => {
    if (!result?.success) {
      return null;
    }
    return result.data;
  }, [result]);

  return (
    <div className="w-100">
      <Table
        data={data?.data ?? []}
        columns={columns}
        isLoadingResults={loading}
        pagination={{
          currentPage: query?.page || 1,
          itemsPerPage: query?.items_per_page || 10,
          onChangePage: (page) => {
            updateQuery({ ...query, page });
          },
          totalItems: data?.total || 0,
          totalPages: data?.total_pages || 0,
        }}
      />
      <SectionTeachersModal ref={sectionTeachersModalRef} />
    </div>
  );
};
export default SectionsTable;
